/**
 * Потеря подтверждения сборки не означает её остановку.
 * Сохраняем части, если нет ни done, ни error: сервер может ещё читать их.
 */
import { abortableDelay } from '../../services/abort.ts'
import { waitForTask } from '../../services/task.ts'
import { UploadError } from './model.ts'

export async function waitForUploadTask(
    read: (signal: AbortSignal) => Promise<Response>,
    signal: AbortSignal,
    wait = abortableDelay,
    maxPolls = 300,
): Promise<void> {
    const result = await waitForTask(read, signal, wait, maxPolls)
    if (result === 'done') return
    if (result === 'failed') throw new UploadError('finalizationFailed')
    if (result === 'access') throw new UploadError('unauthorized', true)

    throw new UploadError('finalizationUnknown', true)
}
